/* eslint-disable react/jsx-pascal-case */
import { ColorPicker } from "antd";
import dayjs from 'dayjs';
import React, { useContext, useEffect, useRef, lazy, Suspense, useState } from "react";
import { default as ProTableOT } from "../../utility/ProTable_ot";
import { useNews } from "../controller/NewsController";
import NewsModal from "./NewsModal";
import NewsTypeModal from "./NewsTypeModal";
import { message, Button, Col, Form, Tag, Row, Space, Popconfirm, Switch, ProTableOt, MainModal, setParamsFilter, useProTableOt, Typography } from "./../../ui/ot";
import NewsTypeForm from "./NewsTypeForm";
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import { useNewsType } from "../controller/NewsTypeController";
const NewsType = ({
    returnButtomText = null,
    onClickReturnButtom = () => { }
}) => {
    const columns = [
        {
            title: '種類',
            dataIndex: 'news_type_name',
            key: 'news_type_name',
        },
        {
            title: '背景顏色',
            dataIndex: 'background_color',
            key: 'background_color',
            render: (text, record, _index) => {
                return <ColorPicker value={record?.background_color ?? "#fee9cb"} disabled={true} showText />
            }
        },
        {
            title: '操作',
            valueType: 'option',
            key: 'option',
            fixed: 'right',
            sorter: false,
            disabled: true,
            render: (text, record, _index) => {
                return (
                    <Space wrap>
                        <Button
                            type="link"
                            style={{
                                color: '#2BC17B'
                            }}
                            onClick={() => {
                                handleEditRow(record)
                            }}
                        >
                            修改
                        </Button>
                        <Popconfirm
                            title="刪除項目"
                            description="確定刪除勾選項目?"
                            onConfirm={() => handleDeleteRow(record?.news_type_id)}
                            onCancel={() => { }}
                        >
                            <Button
                                type="link"
                                danger>
                                刪除
                            </Button>
                        </Popconfirm>
                    </Space>
                )
            }
        },
    ];
    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(20)
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([])
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [...selectedRowKeys]
            let selectRow = [...selectedRowsInfo]
            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.news_type_id)
                    selectRow.push(value)
                })

            }
            else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.news_type_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);

                })
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [...selectedRowKeys]
            let selectRow = [...selectedRowsInfo]
            if (selected) {
                select_temp.push(record.news_type_id)
                selectRow.push(record)
            }
            else {
                select_temp = select_temp.filter(key => key !== record.news_type_id)
                selectRow = selectRow.filter(row => row.news_type_id !== record.news_type_id)
            }
            setSelectedRowKeys(pre => select_temp)
            setSelectedRowsInfo(selectRow)

        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };
    const [modalOpen, setModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)

    const [form] = Form.useForm();

    const [axiosMode, setAxiosMode] = useState("get")
    const onCleanSelected = () => {
        setSelectedRowKeys([])
        setSelectedRowsInfo([])
    }
    const handleAddRow = () => {
        setAxiosMode("post")
        setModalOpen(true)
        form.resetFields()
    }
    const handleEditRow = (record) => {
        setAxiosMode("patch")
        setModalOpen(true)
        form.resetFields()
        form.setFieldsValue({
            ...record,
            background_color: record?.background_color ?? "#fee9cb"
        })
    }
    const handleDeleteRow = (id) => {
        let data = []
        if (id) {
            data = [{
                news_type_id: id
            }]
        }

        else {
            data = selectedRowsInfo.map((val) => {
                return {
                    news_type_id: val?.news_type_id
                }
            })
        }
        if (data.length > 0) {
            NewsTypeController.deleteData(data)
        }
        else {
            message.info("請選擇項目")
        }
    }

    const onFormFinish = (values) => {
        if (axiosMode === "post") {
            NewsTypeController.postData([values])
        }
        else if (axiosMode === "patch") {
            NewsTypeController.patchData([values])
        }
    }
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功")
                actionRef.current.reloadAndRest();

            }
            else if (axiosMode === "patch") {
                message.success("修改成功")
                actionRef.current.reloadAndRest();

            }
            else if (axiosMode === "delete") {
                message.success("刪除成功")
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])

            }
            setModalLoading(false)
            setModalOpen(false)
        }
        else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗")
                actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "patch") {
                message.error("修改失敗")
                actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
                actionRef.current.reloadAndRest();
            }
            setModalLoading(false)
            setModalOpen(false)
        }
    }
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true)
    }
   
    const NewsTypeController = useCRUDController({
        apiRoute: "/system/news/type",
        onFinish,
        onBefore,
    })
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useTableColumnsCheck(columns)
    useEffect(() => {
        checkAll()
    }, [])

    return <Row>
        <Col>
            <NewsTypeModal
                axiosMode={axiosMode}
                propsOpen={modalOpen}
                propsSetOpen={setModalOpen}

                propsForm={form}

                propsLoading={modalLoading}
                propsSetLoading={setModalLoading}

                onFinish={onFormFinish}
            />
        </Col>
        <Col span={24}>
            <ProTableOT
                actionRef={actionRef}
                headerTitle={<Space>
                    <Button
                        type='primary'
                        onClick={() => {
                            handleAddRow()
                        }}
                        style={{
                            backgroundColor: "#FFF9C9",
                            color: "#000"
                        }}
                    >
                        + 新增分類
                    </Button>
                    {returnButtomText && <Button
                        type='primary'
                        onClick={() => {
                            onClickReturnButtom()
                        }}
                        style={{
                            backgroundColor: "#edf3ff",
                            color: "#000"
                        }}
                    >
                        {returnButtomText}
                    </Button>}


                </Space>}
                columns={columns}
                check={check}
                setCheck={setCheck}
                rowKey={'news_type_id'}
                selections={{
                    // onChange: (index_, data_) => set_data(data_)
                }}
                toolBarRender={() => [
                    <Popconfirm
                        title="刪除分類"
                        description="確定刪除勾選分類?"
                        onConfirm={() => handleDeleteRow()}
                        onCancel={() => { }}
                    >
                        <Button
                            type='primary'
                            style={{
                                color: "#000",
                                backgroundColor: "#ffedee"
                            }}

                        >
                            刪除分類
                        </Button>
                    </Popconfirm>
                ]}
                extra_columns={extra_columns}
                set_extra_columns={set_extra_columns}
                manage_columns={false}
                request={async (params = {}, sort, filter) => {
                    setAxiosMode("get")
                    let newParams = {
                    };
                    let order = setOrders(sort)
                    newParams = {
                        ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                        ...newParams,
                        order,
                        size: params.pageSize,
                        cur_page: params.current,
                        custom_filter_value: params.keyword ?? "",
                        custom_filter_key: custom_filter_key
                    };
                    newParams = setParamsFilter({
                        ...newParams,
                    });
                    setPageSize(params?.pageSize ?? 20)
                    return NewsTypeController.getData({ ...newParams })
                }}
                pageSize={pageSize}
                rowSelection={{
                    type: 'checkbox',
                    selectedRowKeys: selectedRowKeys,
                    ...rowSelection,
                }}
                tableAlertOptionRender={() => {
                    return (
                        <Space size={16}>
                            {/* <Typography.Link>匯出資料</Typography.Link> */}
                        </Space>
                    )
                }}
                tableAlertRender={({
                    selectedRowKeys,
                    selectedRows,
                    // onCleanSelected,
                }) => {
                    return (
                        <Space size={24}>
                            <span>
                                已選擇 {selectedRowKeys.length} 項
                                <a style={{ marginInlineStart: 8 }} onClick={onCleanSelected}>
                                    取消選擇
                                </a>
                            </span>
                        </Space>
                    );
                }}
                scroll={{
                    x: "max-content"
                }}

            />
        </Col>
    </Row>
}


const useTableColumnsCheck = (columns) => {
    const [check, setCheck] = useState([])
    const checkAll = () => {
        setCheck((pre) => {
            return columns
                .filter((element) => !element.disabled)
                .map((val) => val.key);
        });
    }
    const setOrders = (sorter) => {
        if (sorter) {
            let newOrders = Object.keys(sorter).map((key, index) => {
                if (sorter[key] === "descend") {
                    return JSON.stringify({
                        column: key,
                        type: 'DESC'
                    })
                }
                else {
                    return JSON.stringify({
                        column: key,
                        type: 'ASC'
                    })
                }

            })
            return newOrders
        }
        else {
            return []
        }
    }
    return {
        check,
        custom_filter_key: check,
        setCheck,
        checkAll,
        setOrders
    }
}

const NewsTypeNew = ({
    returnButtomText = null,
    onClickReturnButtom = () => { },
    permission_level = null,
}) => {
    const columns = [
        {
            title: '種類',
            dataIndex: 'news_type_name',
            key: 'news_type_name',
        },
        {
            title: '背景顏色',
            dataIndex: 'background_color',
            key: 'background_color',
            render: (text, record, _index) => {
                return <ColorPicker value={record?.background_color ?? "#fee9cb"} disabled={true} showText />
            }
        },

    ];
    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(20)
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([])
    const [axiosMode, setAxiosMode] = useState("get")

    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [...selectedRowKeys]
            let selectRow = [...selectedRowsInfo]
            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.news_type_id)
                    selectRow.push(value)
                })

            }
            else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.news_type_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);

                })
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [...selectedRowKeys]
            let selectRow = [...selectedRowsInfo]
            if (selected) {
                select_temp.push(record.news_type_id)
                selectRow.push(record)
            }
            else {
                select_temp = select_temp.filter(key => key !== record.news_type_id)
                selectRow = selectRow.filter(row => row.news_type_id !== record.news_type_id)
            }
            setSelectedRowKeys(pre => select_temp)
            setSelectedRowsInfo(selectRow)

        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };
    const [modalOpen, setModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功")
                actionRef.current.reloadAndRest();

            }
            else if (axiosMode === "patch") {
                message.success("修改成功")
                actionRef.current.reloadAndRest();

            }
            else if (axiosMode === "delete") {
                message.success("刪除成功")
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])

            }
            if(axiosMode !== "get"){
                setModalLoading(false)
                setModalOpen(false)
            }
           
        }
        else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗")
                actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "patch") {
                message.error("修改失敗")
                actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
                actionRef.current.reloadAndRest();
            }
            if(axiosMode !== "get"){
                setModalLoading(false)
                setModalOpen(false)
            }
        }
    }
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true)
    }
    const [form] = Form.useForm();
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns,
    });
    const {
        newsTypeOption,
        getNewsTypeData,
        postNewsTypeData,
        patchNewsTypeData,
        deleteNewsTypeData
    } = useNewsType({
        onFinish: onFinish,
        onBefore: onBefore
    })
    const NewsTypeController = useCRUDController({
        apiRoute: "/system/news/type",
        onFinish,
        onBefore,
    })
    useEffect(() => {
        checkAll()
    }, [])
    return (<Row>
        <Col span={24}>
            <ProTableOt
                actionRef={actionRef}
                columns={columns}
                check={check}
                setCheck={setCheck}
                rowKey={'news_type_id'}
                selections={{
                    // onChange: (index_, data_) => set_data(data_)
                }}
                toolBarRender={() => [
                    returnButtomText && <Button
                        type='primary'
                        onClick={() => {
                            onClickReturnButtom()
                        }}
                        style={{
                            backgroundColor: "#edf3ff",
                            color: "#000"
                        }}
                    >
                        {returnButtomText}
                    </Button>,
                    
                ]}
                extra_columns={extra_columns}
                set_extra_columns={set_extra_columns}
                manage_columns={false}
                request={async (params = {}, sort, filter) => {
                   
                    setAxiosMode("get")
                    let newParams = {
                    };
                    let order = setOrders(sort)
                    newParams = {
                        ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                        ...newParams,
                        order,
                        size: params.pageSize,
                        cur_page: params.current,
                        custom_filter_value: params.keyword ?? "",
                        custom_filter_key: custom_filter_key
                    };
                    newParams = setParamsFilter({
                        ...newParams,
                    });
                    setPageSize(params?.pageSize ?? 20)

                    return getNewsTypeData(newParams)
                }}
                pageSize={pageSize}
                rowSelection={{
                    type: 'checkbox',
                    selectedRowKeys: selectedRowKeys,
                    selectedRowsInfo: selectedRowsInfo,
                    setSelectedRowKeys: setSelectedRowKeys,
                    setSelectedRowsInfo: setSelectedRowsInfo,
                    ...rowSelection,
                }}
              

                scroll={{
                    x: "max-content"
                }}
                propsUseData={() => {
                    return {
                        postData: postNewsTypeData ,
                        patchData:patchNewsTypeData,
                        deleteData: deleteNewsTypeData
                    }
                }}
                PropsPatchForm={<NewsTypeForm 
                />}
                // propsPatchOnFinish={({ axiosMode, status }) => {
                //     if (status === "success") {
                //         actionRef.current.reload()
                //     } else {

                //     }
                // }}
                propsPatchOnBefore={() => { }}
                propsPatch={permission_level === 1 ? true : false}
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                propsDelete={permission_level === 1 ? true : false}
                propsPost={permission_level === 1 ? true : false}
                propsWidth={1000}
                // readonly = {false}
                formMode = {true}
            />
        </Col>
    </Row>)
}

// export default NewsType;
export default NewsTypeNew
